import React from "react";
import { Modal, Box, Typography, Button } from "@mui/material";
import { DELETE_CONFIRMATION_TEXT, DELETE_CONFIRMATION_YES, DELETE_CONFIRMATION_NO, DELETE_CONFIRMATION_HEADER } from "../UserVisibleStrings";

type DeleteConfirmationModalProps = {
    open: boolean,
    onDelete: () => void,
    onClose: () => void,
};

const DeleteConfirmationModal: React.FC<DeleteConfirmationModalProps> = ( { open, onDelete, onClose } ) =>
{
    return (
        <Modal open = {open} onClose = {onClose}>
            <Box
                sx = {{ padding: 2, bgcolor: "background.paper", borderRadius: 1, outline: "none", width: 300, margin: "auto", marginTop: "20%" }}
                onClick = {( event ) =>
                {
                    event.stopPropagation();
                }}
            >
                <Typography variant = "h6">{DELETE_CONFIRMATION_HEADER}</Typography>
                <Typography sx = {{ mt: 2 }}>
                    {DELETE_CONFIRMATION_TEXT}
                </Typography>
                <Box sx = {{ mt: 3, display: "flex", justifyContent: "space-between" }}>
                    <Button variant = "contained" color = "error" onClick = {( event ) =>
                    {
                        event.stopPropagation();
                        onDelete();
                    }}
                    >
                        {DELETE_CONFIRMATION_YES}
                    </Button>
                    <Button variant = "outlined" onClick = {( event ) =>
                    {
                        event.stopPropagation();
                        onClose();
                    }}
                    >
                        {DELETE_CONFIRMATION_NO}
                    </Button>
                </Box>
            </Box>
        </Modal>
    );
};

export default DeleteConfirmationModal;
